@import "../../theme/global";

lar-button-group {
  justify-content: center;
}

h2 {
  text-align: center;
}